<template>
  <div class="not-found-page">
    <h1 class="not-found-404">404</h1>
    <div class="not-found-card">
      <h2 class="not-found-title">{{ $t('notFound.title') || 'Page Not Found' }}</h2>
      <p class="not-found-desc">
        {{ $t('notFound.description') || "The page you are looking for doesn't exist or has been moved." }}
      </p>
      <router-link to="/" class="btn-primary">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
        {{ $t('notFound.backHome') || 'Back to Home' }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundView'
}
</script>

<style scoped>
.not-found-page {
  --blue: #3B82F6; --blue-dim: rgba(59,130,246,0.1);
  --blue-border: rgba(59,130,246,0.28); --blue-glow: rgba(59,130,246,0.35);
  --card-bg: rgba(12,18,32,0.6); --card-border: rgba(255,255,255,0.06);
  --text-muted: #94a3b8; color: white;
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  min-height: 80vh; text-align: center; padding: 2rem 1.5rem;
}

.not-found-404 {
  font-size: clamp(6rem, 15vw, 10rem);
  font-weight: 900;
  background: linear-gradient(135deg, #1d4ed8, #3b82f6, #60a5fa);
  -webkit-background-clip: text; -webkit-text-fill-color: transparent;
  letter-spacing: -0.04em; line-height: 1; margin-bottom: 1.5rem;
  animation: fadeSlideUp 0.8s cubic-bezier(.22,1,.36,1) 0s both;
}

.not-found-card {
  padding: 2.5rem 3rem; border-radius: 24px;
  background: var(--card-bg); border: 1px solid var(--card-border);
  backdrop-filter: blur(16px); text-align: center; max-width: 480px;
  animation: fadeSlideUp 0.8s cubic-bezier(.22,1,.36,1) 0.15s both;
}

.not-found-title { font-size: 1.5rem; font-weight: 800; color: #f1f5f9; margin-bottom: 0.75rem; }
.not-found-desc { font-size: 0.9rem; color: var(--text-muted); line-height: 1.75; margin-bottom: 2rem; }

.btn-primary {
  display: inline-flex; align-items: center; justify-content: center; gap: 8px;
  background: var(--blue); color: #fff; font-weight: 700; font-size: 0.9rem;
  padding: 0.8rem 1.8rem; border-radius: 10px; border: none; cursor: pointer;
  text-decoration: none; position: relative; overflow: hidden;
  transition: background 0.2s, transform 0.2s, box-shadow 0.2s;
}
.btn-primary::after { content: ''; position: absolute; inset: 0; background: linear-gradient(135deg, rgba(255,255,255,0.15), transparent); opacity: 0; transition: opacity 0.25s; }
.btn-primary:hover { background: #2563eb; transform: translateY(-3px); box-shadow: 0 10px 32px var(--blue-glow); }
.btn-primary:hover::after { opacity: 1; }

@keyframes fadeSlideUp {
  from { opacity: 0; transform: translateY(30px); filter: blur(6px); }
  to   { opacity: 1; transform: translateY(0); filter: blur(0); }
}
</style>